import registerSignInLegacy from "./register_signin_legacy.js";
import doRegistration from "./do_registration.js";
import doLogin from "./do_login.js";
import resetPassword from "./reset_password.js";
import sendResetPasswordLink from "./send_reset_password_link.js";

export default {
    registerSignInLegacy,
    doRegistration,
    doLogin,
    resetPassword,
    sendResetPasswordLink
}
